import { SvgIcon, SvgIconProps } from '@mui/material';

export const MapSearchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_896_8200"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_896_8200)">
        <path
          fill="currentColor"
          d="M4.35 20.7c-.333.133-.642.096-.925-.113C3.142 20.38 3 20.1 3 19.75V5.75c0-.217.063-.408.188-.575.125-.167.295-.292.512-.375L9 3l6 2.1 4.65-1.8c.333-.133.642-.096.925.113.283.208.425.487.425.837v8.425a4.87 4.87 0 0 0-.888-1.05A4.947 4.947 0 0 0 19 10.8V5.7l-3 1.15V10c-.35 0-.692.03-1.025.088-.333.058-.658.145-.975.262V6.85l-4-1.4v13.075L4.35 20.7ZM5 18.3l3-1.15V5.45L5 6.45v11.85ZM16 18c.567 0 1.038-.167 1.413-.5.375-.333.57-.833.587-1.5.017-.567-.17-1.042-.562-1.425-.392-.383-.871-.575-1.438-.575-.567 0-1.042.192-1.425.575-.383.383-.575.858-.575 1.425 0 .567.192 1.042.575 1.425.383.383.858.575 1.425.575Zm0 2c-1.1 0-2.042-.392-2.825-1.175C12.392 18.042 12 17.1 12 16c0-1.1.392-2.042 1.175-2.825C13.958 12.392 14.9 12 16 12c1.1 0 2.042.392 2.825 1.175C19.608 13.958 20 14.9 20 16c0 .383-.046.746-.138 1.088-.091.341-.229.662-.412.962L22 20.6 20.6 22l-2.55-2.55a4.93 4.93 0 0 1-.962.413c-.342.091-.705.137-1.088.137Z"
        />
      </g>
    </svg>
  </SvgIcon>
);

MapSearchIcon.muiName = 'MapSearchIcon';
